import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { PhxUnderlineColor, PhxUnderlineType } from './phx-underline.type';

@Component({
  selector: '[phx-underline]',
  template: `<ng-content></ng-content>`,
  styleUrls: ['./phx-underline.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'phx-underline',
    '[class.phx-underline-default]': `phxUnderlineType === 'default'`,
    '[class.phx-underline-override]': `phxUnderlineType === 'override'`,
    '[class.phx-underline-link]': `phxUnderlineType === 'link'`,
    '[class.phx-underline-color-default]': `phxUnderlineColor === 'default'`,
    '[class.phx-underline-color-warning]': `phxUnderlineColor === 'warning'`,
    '[class.phx-underline-color-active]': `phxUnderlineColor === 'active'`,
    '[class.phx-underline-hide]': `phxHideUnderline`,
  },
})
export class PhxUnderlineComponent {
  @Input() phxUnderlineType: PhxUnderlineType = 'default';
  @Input() phxUnderlineColor: PhxUnderlineColor = 'default';
  @Input() phxHideUnderline: boolean = false;
}
